import { Stack, Typography } from "@mui/material";
import { format } from "date-fns";

export default function DurationDescription({ bookableDuration }) {
  if(bookableDuration.duration_type === "full_day") {
    return (
      <Stack>
        <Typography>{bookableDuration.days} Day{bookableDuration.days > 0 && 's'}</Typography>
      </Stack>
    );
  } else if(bookableDuration.duration_type === "hourly") {
    return (
      <Stack>
        <Typography>{bookableDuration.hours} Hours {bookableDuration.minutes && `${bookableDuration.minutes} Minutes`}</Typography>
      </Stack>
    );
  } else if(bookableDuration.duration_type === "scheduled") {
    return (
      <Stack direction="row" spacing={0.5}>
        <Typography>
          {format(new Date(bookableDuration.start_time), 'hh:mm aa')} - {format(new Date(bookableDuration.end_time), 'hh:mm aa')}
        </Typography>
      </Stack>
    );
  }
}